import React from "react";
import LeftImgRightText from "../components/re-usable/cards/left-img-right-text";
type articleType = {
  date: string;
  author: string;
  icon: string;
  category: string;
  title: string;
  description: string;
  img: string;
  alt: string;
  showHomePage: boolean;
  articleURL: string
}[];

interface cardsType {
  cardData: {
    title: string;
    link: string;
    article: articleType;
  }[];
  page?: string;
  query?: string;
}

const Card = (props: cardsType) => {
  const { cardData, page, query } = props;
  let showHomePageItem: articleType = [];
  return (
    <>
      {cardData.map((item, index) => {
        item.article.map((item) => (item.showHomePage ? showHomePageItem.push(item) : ""));
        return (
          <React.Fragment key={index}>
            {(page === undefined || page === null || page === "") && (
              <div className="col-lg-6 discover" >
                <div className="row">
                  <h2>
                    <a href={item.link.toLowerCase()}>{item.title} »</a>
                  </h2>
                </div>
                <LeftImgRightText article={showHomePageItem} />
              </div>
            )}
            {page === "profile" && (
              <div className="col-lg-6  dis-flex">
                <div>
                  <div className="col-md-12">
                    <h3>
                      <a href={item.link.toLowerCase()}>{item.title} »</a>
                    </h3>
                  </div>
                  <div className="row">
                    <LeftImgRightText article={showHomePageItem} page={"profile"} />
                  </div>
                  <div className="col-md-12">
                    <a href={"/search?" + (query ? query : "marketplace=3&amp;taxonomy=")}>See All Relevant {item.title}»</a>
                  </div>
                </div>
              </div>
            )}
          </React.Fragment>
        );
      })}
    </>
  );
};

export default Card;
